<template>
    <div class="par_wrap">
        <p class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          返回上一页</p>
        <div class="box">
            <h2>查看并操作</h2>
            <ParheaderVue :caseid="caseid" :token="token"/>
            <Parinf :caseid="caseid" :token="token" />
        <Parinf1 />
        </div>
    </div>
</template>

<script>
import constants from '@/util/constants.js';
import ParheaderVue from "../par/parheader.vue";
import Parinf from "../par/Parinf.vue";
import Parinf1 from "./Parinf.vue";
export default {
  components: {
    ParheaderVue,
    Parinf,
    Parinf1
  },
  data() {
    return {
      token: this.$route.params.token||JSON.parse(window.localStorage.getItem("data")).data,
      obj: {},
      victimList: null,
      casenumber: "AJ200101",
      inf: null,
      init: null,
      obj2: null,
      typeId:this.$route.query.typeId,
      caseid:this.$route.query.caseid
    };
  },
  methods: {
    back() {
      let that = this;
      console.log(that.token);
      this.$router.push({
        path: "/regulator/caseindex/await",
        name: "RegAwait",
        params: {
          token: that.token
        },
        query: {
          typeId:this.$route.query.typeId
        }
      });
    },
  },
};
</script>

<style scoped>
@import url(../../css/par.css);
</style>



// WEBPACK FOOTER //
// src/components/regulator/Par.vue